import axios from 'axios'

interface State {
    deviceToken: string
    isNativeApp: boolean
    browser: string
    os: string
}

const defaults = () => {
    return {
        deviceToken: null,   //  The unique identifier of this device (we persist this id server-side)
        isNativeApp: false,  //  Indicates if the app is running as a Native mobile app (ie iOS or Andriod)
        browser: null,       //  The browser currently hosting the app
        os: null             //  The operating system currently hosting the app
    }
}

export default {
    state: defaults(),
    mutations: {
        browserSet (state: State): void {
            const browser = (function(){
                const test = function(regexp) { return regexp.test(window.navigator.userAgent);}
                switch(true){
                    case test(/edge/i): return "Edge";
                    case test(/opr/i) && (!!window.opr || !!window.opera): return "Opera";
                    case test(/chrome/i) && !!window.chrome: return "Chrome";
                    case test(/trident/i) : return "IE";
                    case test(/firefox/i) : return "Firefox";
                    case test(/safari/i): return "Safari";
                    case test(/AppleWebKit/i): return "Safari"
                    default: return window.navigator.userAgent;
                }
            })();
            state.browser = browser
        },
        osSet (state: State): void {
            /**
            * /iPad|iPhone|iPod/ will detect IE11 as well.  Microsofts added the work 'iPhone'
            * to their User-Agent string in an attempt to fix mobile behavior.
            * laugh at them.
            */

            const os = (function(){
                const test = function(regexp) { return regexp.test(window.navigator.userAgent);}
                switch(true){
                    case test(/Win/i): return "windows";
                    case test(/iPad|iPhone|iPod/i): return "iOS"
                    case test(/Mac/i): return "MacOs";
                    case test(/x11/i): return  "Unix";
                    case test(/Linux/i) : return "Linux";
                    case test(/Andriod/i): return "Andriod";
                    default: return "other";
                }
            })();
            state.os = os
        },
        deviceReset(state: State): void {
            Object.assign(state, defaults())
        },
        deviceTokenSet(state: State, token: string): void {
            state.deviceToken = token
        },
        isNativeAppSet(state: State, bool: boolean) : void {
            state.isNativeApp = bool
        }
    },
    actions: {
        deviceTokenPost ({commit, getters}, token) {
            return axios.post(`${getters.api}/device-token`, token).then(response => {
                commit('deviceTokenSet', token.token)
                return response.data
            }).catch(() => {
                return null
            })
        },
    },
    getters: {
        deviceToken(state: State): string {
            return state.deviceToken
        },
        browser (state: State): string {
            return state.browser
        },
        isApp (state: State): boolean {
            return state.isNativeApp
        },
        isMobile: () => (type = null) => {
            let device = {
                ios: /iPhone|iPad|iPod/i,
                nonIos: /Android|Blackberry|Windows Phone/i
            }[type] || /Android|webOS|iPhone|iPad|iPod|Blackberry|Windows Phone/i
            return device.test(navigator.userAgent)
        },
        isNativeApp (state: State): boolean {
            return state.isNativeApp
        },
        os (state: State): string {
            return state.os
        }
    }
}
